function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import angular from 'angular';
import { cloneDeep } from 'lodash';
import moment from 'moment';
import { AccesoDatos } from 'src/_candidato/comun/services/acceso-datos';
import { TiposDocEstadosStore } from 'src/_candidato/data/tiposStore';
import { BaseFeaturesComponent } from '../_base/base-features.component';
import './panel-delete-curriculums.scss';
function fechaMenos(amount, unit) {
  return fechaMenosM(amount, unit).toDate();
}
function fechaMenosM(amount, unit) {
  var _m = moment();
  if (amount) {
    _m.add(-1 * amount, unit);
  }
  return _m;
}
var FILTRO_DEFECTO = {
  idcv: null,
  limit: 50,
  end: null,
  start: null,
  estado: null,
  mainq: null,
  q_value: null,
  usuarioGestor: null,
  listarPublicos: null
};
var FILTROS = [{
  title: 'Filter by date',
  desc: 'Last month',
  page: 'Curriculums Between Dates',
  onactivate: function onactivate(ctrl) {
    ctrl.filtrarFechas();
  },
  onend: function onend(ctrl) {
    ctrl.filtrarFechas(false);
  },
  filtros: function filtros(ctrl) {
    return {
      limit: -1,
      end: ctrl.filtroFechas.fin && new Date(ctrl.filtroFechas.fin) || null,
      start: ctrl.filtroFechas.inicio && new Date(ctrl.filtroFechas.inicio) || null,
      estado: null,
      mainq: null,
      q_value: null
    };
  }
}];
var PanelDeleteCurriculumsCtrl = /*#__PURE__*/function (_BaseFeaturesComponen) {
  PanelDeleteCurriculumsCtrl.$inject = ["$element", "$log", "$timeout", "AccesoDatos", "appConfigService"];
  function PanelDeleteCurriculumsCtrl($element, $log, $timeout, AccesoDatos, appConfigService) {
    var _this;
    _classCallCheck(this, PanelDeleteCurriculumsCtrl);
    _this = _callSuper(this, PanelDeleteCurriculumsCtrl, [appConfigService]);
    _defineProperty(_this, "$loading", false);
    _defineProperty(_this, "filtroActivo", null);
    _defineProperty(_this, "panelcv", {
      $visible: false,
      cv: null
    });
    _defineProperty(_this, "filtroFechas", {
      visible: false,
      inicio: null,
      fin: fechaMenosM(1, 'year').format('ll')
    });
    _defineProperty(_this, "total", {
      count: 0,
      valid: false
    });
    _defineProperty(_this, "_estados", {
      REVISED: 'zzzzzz'
    });
    _defineProperty(_this, "delete", {
      active: false,
      confirm: false,
      processing: false,
      cvmap: {},
      msgs: []
    });
    _this.$element = $element;
    _this.$log = $log;
    _this.$timeout = $timeout;
    _this.AccesoDatos = AccesoDatos;
    return _this;
  }
  _inherits(PanelDeleteCurriculumsCtrl, _BaseFeaturesComponen);
  return _createClass(PanelDeleteCurriculumsCtrl, [{
    key: "$onInit",
    value: function $onInit() {
      var _this2 = this;
      this.$log.info('[PanelDeleteCurriculumsCtrl] onInit');
      this.filtrosList = cloneDeep(FILTROS);
      this.activaFiltro(this.filtrosList[0]);
      this.AccesoDatos.Datos_Client.tiposParaDocuemntos().then(function (tiposResponse) {
        return _this2.datosTipos = new TiposDocEstadosStore(tiposResponse);
      });
    }
  }, {
    key: "_busqueda",
    value: function _busqueda() {
      var _this3 = this;
      this._resetDelete();

      // al inicio, obtener los ítems de menú disponibles, no solo los visibles
      var filtros;
      if (this.filtros) {
        var _filtrosBusqueda = this.filtroActivo && this.filtroActivo.filtros(this) || cloneDeep(FILTRO_DEFECTO);
        filtros = this._busquedaClient().listCV(_filtrosBusqueda);
      } else filtros = this._busquedaClient().lastCV();
      filtros.then(function (listadoResponse) {
        _this3.$log.info('listado', listadoResponse);
        _this3.listado = null;
        _this3.listadolist = null;
        _this3.$timeout(function () {
          _this3.listado = listadoResponse;
          _this3.listadolist = listadoResponse.list;
        });
      });
    }
  }, {
    key: "_busquedaClient",
    value: function _busquedaClient() {
      if (this.esAdmin()) {
        return this.AccesoDatos.GestionCurr_CLIENT;
      } else {
        return this.AccesoDatos.GestionSolicitudes_CLIENT;
      }
    }
  }, {
    key: "accesscv",
    value: function accesscv(idx) {
      this.$log.debug('access', this.listado.list[idx]);
      this.panelcv.cv = this.listado.list[idx];
      this.panelcv.$visible = true;
    }
  }, {
    key: "filtrarFechas",
    value: function filtrarFechas(forzar) {
      this.filtroFechas.visible = forzar !== null && forzar !== void 0 ? forzar : !this.filtroFechas.visible;
    }
  }, {
    key: "aplicaFiltros",
    value: function aplicaFiltros() {
      this._busqueda();
    }
  }, {
    key: "activaFiltro",
    value: function activaFiltro(f) {
      var _this$filtroActivo;
      ((_this$filtroActivo = this.filtroActivo) === null || _this$filtroActivo === void 0 ? void 0 : _this$filtroActivo.onend) && this.filtroActivo.onend(this);
      this.filtroActivo = f;
      f.onactivate(this);
    }
  }, {
    key: "estadoDesc",
    value: function estadoDesc(f) {
      this.$log.info(' estadoDesc!!!!!!', f);
      return f.cv.estado + ' xxx';
    }
  }, {
    key: "updateAccionCV",
    value: function updateAccionCV(cvdata) {
      this.$log.info(' update!!!!!!', cvdata);
      var _actualcv = this.panelcv.cv;
      _actualcv.cv.estado = cvdata.actionitem.state;
    }
  }, {
    key: "estados",
    get: function get() {
      this.$log.info('====> estados!!!!');
      return this._estados;
    }
  }, {
    key: "deletecv",
    value: function deletecv() {
      this["delete"].processing = false;
      this["delete"].active = !this["delete"].active;
      if (this["delete"].active) {
        this["delete"].confirm = true;
        this["delete"].msgs = [];
      }
      this.$log.info('selected', this["delete"].cvmap);
    }
  }, {
    key: "_resetDelete",
    value: function _resetDelete() {
      this["delete"] = {
        active: false,
        confirm: false,
        processing: false,
        cvmap: {},
        msgs: []
      };
    }
  }, {
    key: "reallyDelete",
    value: function reallyDelete() {
      this["delete"].confirm = false;
      this["delete"].processing = true;
      this["delete"].msgs.push('-- Process start --');
      this.process(0);
    }
  }, {
    key: "process",
    value: function () {
      var _process = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(idx) {
        var _this4 = this;
        var _cv, _id, _result;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              if (this["delete"].processing) {
                _context.n = 1;
                break;
              }
              return _context.a(2);
            case 1:
              if (!(idx >= this.listado.list.length)) {
                _context.n = 2;
                break;
              }
              this["delete"].msgs.push('-- Process finished --');
              return _context.a(2);
            case 2:
              _cv = this.listado.list[idx];
              _id = _cv.cv.idcv;
              _result = null;
              if (!this["delete"].cvmap[_id]) {
                _context.n = 4;
                break;
              }
              _context.n = 3;
              return this._deletecv(_cv);
            case 3:
              _result = _context.v;
              this["delete"].msgs.push("Delete C.V. Id ".concat(_id, " ( ").concat(moment(_cv.cv.fcalta).format('DD MMM YY HH:mm'), " ):  Success"));
            case 4:
              // para actualizar los mensajes
              this.$timeout(function () {
                var result = _this4.process(idx + 1);
              }, 5);
              return _context.a(2, _result);
          }
        }, _callee, this);
      }));
      function process(_x) {
        return _process.apply(this, arguments);
      }
      return process;
    }()
  }, {
    key: "_deletecv",
    value: function () {
      var _deletecv2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(_cv) {
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              if (!this.esAdmin()) {
                _context2.n = 1;
                break;
              }
              return _context2.a(2, this.AccesoDatos.HistoricCurr_CLIENT.borrarCv(_cv.cv.form_id, _cv.cv.idcv));
            case 1:
              return _context2.a(2, this.AccesoDatos.HistoricSolicitudes_CLIENT.borrarCv(_cv.cv.form_id, _cv.cv.idcv));
            case 2:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function _deletecv(_x2) {
        return _deletecv2.apply(this, arguments);
      }
      return _deletecv;
    }()
  }, {
    key: "selectAll",
    value: function selectAll() {
      var _this5 = this;
      this.listado.list.forEach(function (cv) {
        return _this5["delete"].cvmap[cv.cv.idcv] = true;
      });
    }
  }]);
}(BaseFeaturesComponent);
angular.module('candidato').component('panelDeleteCurriculums', {
  bindings: {
    filtros: '<'
  },
  controller: PanelDeleteCurriculumsCtrl,
  template: require('./panel-delete-curriculums.component.html')
  // templateUrl: "panel-delete-curriculums.component.html",
});